export interface Input {
  onUpdate: (el: HTMLVideoElement) => void;
}

<script>
  const stream = await navigator.mediaDevices.getUserMedia({
    audio: false,
    video: {
      width: { ideal: 640 },
      height: { ideal: 480 },
      facingMode: "environment",
      frameRate: { ideal: 15 }
    },
  });

  const room = joinRoom({
    appId: "zoomgle-cardboard",
    rtcConfig: {
      iceServers: [
        { urls: 'stun:stun.l.google.com:19302' },
        { urls: 'stun:stun1.l.google.com:19302' },
        { urls: 'stun:stun2.l.google.com:19302' },
        { urls: 'stun:stun3.l.google.com:19302' },
        { urls: 'stun:stun4.l.google.com:19302' }
      ]
    }
   }, "the-only-room");
  room.onPeerStream((stream) => {
    video().srcObject = stream;
  })
  room.onPeerJoin(peer => {
    room.addStream(stream, peer);
  })
</script>

<let/frameCount=0/>
<script>
  if (frameCount) {
    input.onUpdate(video());
    frameCount++;
  }
</script>

<video/video
  width=0
  height=0
  muted
  autoplay
  playsinline
  onLoadedData() {
    video().play()
    frameCount++;
  }
/>

import { joinRoom } from "trystero"